import { EHttpMethod } from '../common/enums/fetch.enum';

export default class FApiRoutes {
  public method: EHttpMethod;
  public url: string;

  public static getBlogEntries = new FApiRoutes(`/blogs`, EHttpMethod.GET);
  public static getBoxes = new FApiRoutes(`/boxes`, EHttpMethod.GET);
  public static getQuickLinks = new FApiRoutes(`/quick-links`, EHttpMethod.GET);
  public static getSlides = new FApiRoutes(`/slides`, EHttpMethod.GET);
  public static getSocialMedias = new FApiRoutes(`/social-medias`, EHttpMethod.GET);

  constructor(url: string, method: EHttpMethod) {
    this.method = method;
    this.url = url;
  }
}
